(function () {
  function initGallery(root) {
    var main = root.querySelector("[data-kirppis-gallery-main]");
    var thumbs = root.querySelectorAll("[data-kirppis-gallery-thumb]");
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-full-src");
        var alt = thumb.getAttribute("data-alt") || "";
        if (!src) return;
        main.src = src;
        main.alt = alt;
        thumbs.forEach(function (other) {
          var active = other === thumb;
          other.classList.toggle("is-active", active);
          other.setAttribute("aria-pressed", active ? "true" : "false");
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll("[data-kirppis-product-gallery]").forEach(initGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
